export const BASE_URL = "https://gaa.international";
export const HOME_ROUTE = "/";
export const FIND_CLUB_ROUTE = "/find-a-club";
export const CLUBS_ROUTE = "/clubs";
export const MY_ACCOUNT_ROUTE = "/my-account";
export const LOGIN_ROUTE = "/login";
export const REGISTER_ROUTE = "/register";
export const PRIVACY_POLICY_ROUTE = "/privacy-policy";
export const TERMS_CONDITIONS_ROUTE = "/terms-conditions";
export const CONTACT_ROUTE = "/contact-us";
export const USER_ROUTE = "/user";
export const ABOUT_ROUTE = "/about-us";
export const SITEMAP_ROUTE = "/sitemap.xml";
export const BLOG_ROUTE = "/blog";
export const ATTACT_MORE_PLAYERS_ROUTE = "/3-tips-to-attract-more-players";
export const FACKBOOK_LINK = "https://www.facebook.com/GAAInternational";
export const TWITTER_LINK = "https://twitter.com/GAA_Intl";
export const INSTAGRAM_LINK = "https://www.instagram.com/gaa_intl/";
export const EMAIL_LINK = "mailto:info@gaa.international";



// WEBPACK FOOTER //
// ./src/constants/route.constants.js